module.exports = __webpack_public_path__ + "img/3efbb2b749a241ecff0d4dbe2b04de13.835b7cf5.png";